// extracted by mini-css-extract-plugin
module.exports = {"logo":"AppLogo_logo__2ubXB","withName":"AppLogo_withName__334n0"};